import { fetchAllTags } from 'actions';
import AntitrustAssessment from 'components/AntitrustAssessment';
import { RouteSpec, SuperRouteSpec } from 'types';

const antitrustAssessmentRoutes: (RouteSpec | SuperRouteSpec)[] = [
  {
    name: 'antitrust-assessment',
    path: '/:customerDomain/antitrust-assessment',
    component: AntitrustAssessment,
    private: true,
    permissions: 'analytics.list',
    data: {
      actions: [fetchAllTags],
      params: {
        tags: {
          nestedResource: true,
          params: {
            limit: {
              defaultValue: '-1',
            },
            offset: {
              defaultValue: '0',
            },
            order_by: {
              defaultValue: 'value',
            },
            order_desc: {
              defaultValue: 'false',
            },
          },
        },
      },
    },
  },
];

export default antitrustAssessmentRoutes;
